<template>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'
  import {landingPage} from '@/util/landingPage.js'

  export default {
    name: 'Token',
    data() {
      return {

      };
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getHistoryPage() {
        return this.$store.state.historyPage
      }
    },
    methods: {

    },
    created() {
      let self = this;
      // Component accessed when going on route: base_url/token/{token}
      // We are taking the token and logging users in, and after that, redirecting to homepage
      if (this.$route.params.token) {
        if (this.$route.params.token == 'invalid') {
          setTimeout(function() {
            self.$router.push({name: 'login', params: {error: true}})
          }, 300)

        } else {
          let token = this.$route.params.token;
          localStorage.setItem('token', token);
          piincHttp.defaults.headers.common['Authorization'] = token;

          // Super admins start on Administration, so ask who signed in, without the client list (US 9436)
          let land = function(isAdmin) {
            let page = landingPage(self.getHistoryPage, isAdmin);
            self.$store.commit('storeHistoryPage', '');
            window.location.href = page;
          };
          piincHttp.get('users/me', { params: { without_clients: 1 }, headers: { Authorization: 'Bearer ' + token } }).then(function(response) {
            land(response.data.user && response.data.user.isAdmin);
          }, function() {
            land(false);
          });
        }
      }
    }
  }

</script>
